import {
    TagIcon,
    ShieldCheckIcon,
    PhoneIcon,
    CalendarDaysIcon,
} from "@heroicons/react/24/outline";

export default function BookingBenefits() {
    const benefits = [
        {
            icon: TagIcon,
            title: "Best Price Guarantee",
            description: "Get the best prices or we'll match it",
        },
        {
            icon: ShieldCheckIcon,
            title: "Secure Booking",
            description: "Your booking is safe and protected",
        },
        {
            icon: PhoneIcon,
            title: "24/7 Customer Support",
            description: "We're here to help you anytime",
        },
        {
            icon: CalendarDaysIcon,
            title: "Free Cancellation",
            description: "Flexible plans with free cancellation",
        },
    ];

    return (
        <section className="w-full px-4 sm:px-6 lg:px-8 mt-8">
            <div className="max-w-7xl mx-auto">

                {/* Benefits Card */}
                <div className="
                    bg-white
                    rounded-2xl
                    border border-gray-100
                    shadow-sm
                    px-5 sm:px-6 lg:px-8
                    py-5 sm:py-6
                ">

                    <div className="
                        grid
                        grid-cols-1
                        sm:grid-cols-2
                        lg:grid-cols-4
                    ">
                        {benefits.map((benefit, index) => {
                            const Icon = benefit.icon;

                            return (
                                <div
                                    key={benefit.title}
                                    className={`
                                        flex items-center gap-4
                                        px-3 sm:px-5
                                        py-4
                                        ${index !== benefits.length - 1
                                            ? "lg:border-r lg:border-gray-200"
                                            : ""
                                        }
                                        ${index === 1
                                            ? "sm:border-r sm:border-gray-200 lg:border-r"
                                            : ""
                                        }
                                    `}
                                >

                                    {/* Icon */}
                                    <div className="
                                        flex-shrink-0
                                        w-12 h-12
                                        rounded-full
                                        bg-[#174EA6]/10
                                        flex items-center justify-center
                                    ">
                                        <Icon
                                            className="w-6 h-6 text-[#174EA6]"
                                            strokeWidth={1.8}
                                        />
                                    </div>

                                    {/* Content */}
                                    <div className="min-w-0">
                                        <h3 className="
                                            text-sm
                                            font-bold
                                            text-[#0F172A]
                                            leading-tight
                                            mb-1
                                        ">
                                            {benefit.title}
                                        </h3>

                                        <p className="
                                            text-xs
                                            text-gray-500
                                            leading-relaxed
                                        ">
                                            {benefit.description}
                                        </p>
                                    </div>

                                </div>
                            );
                        })}
                    </div>

                </div>

            </div>
        </section>
    );
}